export const SAML_DEFAULT_SETTINGS = {
  entity_id: '',
  sso_url: '',
  certificate: ''
}

export const SAML_STEPS = {
  INITIAL: 1,
  CONFIGURED: 2,
  TESTED: 3,
  ENFORCED: 4
}
export const SAML_INITIAL_STEP = SAML_STEPS.INITIAL

export const STATE_CONFIGURED = 'configured'
export const STATE_ENFORCED = 'enforced'

export const STATE_TESTED = 'tested'
